import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable()

export class Interceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url.includes(environment.mulesoftApi)) {
      return next.handle(request);
    }
    if (request.url.includes('https://login.motracking.ch/api')) {
      return next.handle(request);
    }
    const token: string = sessionStorage.getItem('Token');

    if (!request.headers.has('Content-Type')) { request = request.clone({headers: request.headers.set('Content-Type', 'application/json')}); }
    if (request.url === environment.apiPath + 'login') { request = request.clone({headers: request.headers.set('Content-Type', 'application/x-www-form-urlencoded')}); }
    if (token) {  request = request.clone({headers: request.headers.set('Authorization', 'Bearer ' + token)}); }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      }));
  }
}
